import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import { useId, useState } from "react";
import type { ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { cn } from "@volca/ui/lib/utils";

interface CollapsibleSectionProps {
  label: string;
  children: ReactNode;
}

export const CollapsibleSection = ({
  label,
  children,
}: CollapsibleSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentId = useId();
  const buttonId = `${contentId}-button`;

  return (
    <div className="mt-2">
      <Button
        id={buttonId}
        variant="ghost"
        size="xs"
        aria-controls={contentId}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((prev) => !prev)}
        className="-ml-2 text-subtle"
      >
        <CaretRightIcon
          className={cn("size-3 transition-transform", {
            "rotate-90": isExpanded,
          })}
        />
        {label}
      </Button>
      {isExpanded && (
        <div
          id={contentId}
          role="region"
          aria-labelledby={buttonId}
          className="mt-2 border-l pl-3"
        >
          {children}
        </div>
      )}
    </div>
  );
};
